import { useDataChange } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'professional_search',
    path: 'term',
  })
  let setFlowTo = useSetFlowTo(props.viewPath)
  return function onClick(value) {
    change(value)
    if (value.length < 3) {
      setFlowTo(normalizePath(props.viewPath, '../Professionals/No'))
    }
  }
}
